import { useQuery, QueryResult } from '@apollo/client'
import { Country, FindTalentsSeasonsYearsQuery, FindTalentsSeasonsYearsQueryVariables } from '../../types'
import { TALENTS_SEASON_YEARS } from './Queries'

export const useTalentsSeasonYears = (
  companyId: string,
  country: Country,
): QueryResult<FindTalentsSeasonsYearsQuery, FindTalentsSeasonsYearsQueryVariables> => {
  return useQuery<FindTalentsSeasonsYearsQuery, FindTalentsSeasonsYearsQueryVariables>(TALENTS_SEASON_YEARS, {
    variables: { companyId, country },
    fetchPolicy: 'network-only',
  })
}
